import { RelatedBadges } from "./RelatedBadges";
import { buildRelatedUrl, pluralizeAsins } from "../relatedLinks";

// Attached to each listings row by the listingsTable lambda on every read.
// Counts are distinct non-merchant ASINs, matching what each badge's panel shows.
export interface RelatedListings {
  equal_count: number;
  shared_count: number;
  shared_product_ids: number[];
  inventory_ids: number[];
}

export function RelatedListingsCell({
  productId,
  related,
}: {
  productId?: number | null;
  related?: RelatedListings | null;
}) {
  if (productId === null || productId === undefined || !related) return null;

  // Both badges show this product's own parts in the inventory panel
  const { equal_count, shared_count, shared_product_ids, inventory_ids } =
    related;

  return (
    <RelatedBadges
      equal={{
        count: equal_count,
        href: buildRelatedUrl({
          productIds: [productId],
          inventoryIds: inventory_ids,
        }),
        tooltip: `Equal: ${pluralizeAsins(
          equal_count
        )} of product ${productId}`,
      }}
      shared={{
        count: shared_count,
        href: buildRelatedUrl({
          productIds: shared_product_ids,
          inventoryIds: inventory_ids,
        }),
        tooltip: `Shared: ${pluralizeAsins(shared_count)}`,
      }}
    />
  );
}
